import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { ClipboardList, Settings2 } from "lucide-react";
import IntermediateTestDialog from "./IntermediateTestDialog";

/**
 * Compact intermediate-test config for a module.
 * Displayed inside ModuleBlock.
 */
export default function IntermediateTestSection({ moduleId, courseQuestions }) {
  const [test, setTest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/modules/${moduleId}/intermediate-test`);
      setTest(data);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  // load() dipende solo da moduleId (già nelle deps).
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [moduleId]);

  return (
    <div data-testid={`intermediate-section-${moduleId}`} className="border-t border-brand-line pt-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-brand-ink">
          <ClipboardList size={14} className="text-brand-blue" /> Test intermedio
        </div>
        <button
          type="button"
          onClick={() => setOpen(true)}
          data-testid={`intermediate-configure-${moduleId}`}
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue hover:underline underline-offset-4"
        >
          <Settings2 size={14} /> {test ? "Modifica" : "Configura"}
        </button>
      </div>
      {loading ? (
        <div className="text-xs text-brand-muted mt-2">Caricamento…</div>
      ) : test ? (
        <div className="text-sm text-brand-muted mt-1">
          <span className="font-semibold text-brand-blue" data-testid={`intermediate-question-count-${moduleId}`}>
            {test.questions_per_attempt || test.question_ids.length}
          </span> domande per tentativo
          {test.questions_per_attempt && test.questions_per_attempt < test.question_ids.length ? (
            <> (estratte da {test.question_ids.length})</>
          ) : null}
          {" · "}Punteggio minimo <span className="font-semibold">{test.passing_score}</span> · Max <span className="font-semibold">{test.max_attempts}</span> tentativi.
        </div>
      ) : (
        <div className="text-sm text-brand-muted mt-1">Nessun test configurato per questo modulo.</div>
      )}

      <IntermediateTestDialog
        open={open}
        onOpenChange={setOpen}
        moduleId={moduleId}
        courseQuestions={courseQuestions}
        existing={test}
        onSaved={(t) => setTest(t)}
        onDeleted={() => setTest(null)}
      />
    </div>
  );
}
